(function ($) {
    /* search box plugin */
       
    $.fn.searchBox = function (options) {
        // Set the variables accesible at the plugins front end.
        options = $.extend({
            placeholder: 'Search', // edit placeholder text
            width: '100%', // set width
            showSearchIcon: true,
            search: null,
            color: "", // only "dark"
            change: null,
            clear: null,
            clearAfterSearch: false

        }, options);

        // Set what you want the plugin to actually do.
        return this.each(function () {
            var searchIcon = "mpSearchGo";
            var invalidKeys = [13, 38, 40, 37, 39, 27, 32, 16, 18, 9, 20, 91, 93, 36, 35, 45, 33, 34, 144, 112, 123, 145, 19]; // invalid key codes

            if (options.showSearchIcon === false) {
                searchIcon = "mpNoSearch";
            } 

            $(this).val("")
            .addClass("txtSearchText")
			.attr({
			    "onfocus": "this.placeholder = ''",
			    "onblur": "this.placeholder = '" + options.placeholder + "'",
			    "placeholder": options.placeholder
			})
			.wrap("<div class='mpSearchOuter " + options.color + " " + searchIcon + " no-text'><div class='inputWrap' /></div>")
			.after("<a class='fa fa-times-circle mpSearchClear'></a>")
			.before("<a class='fal fa-search " + searchIcon + "'></a>");

            var wrapper = $(this).parent().parent();

            wrapper.css("width", options.width); // sets width of search

            wrapper.find(".mpSearchGo").click(function () { // on search icon click
                if (options.showSearchIcon === true) {
                    options.search($(this).next().val());
                    //console.log($(this).next().val());
                }
            });

            wrapper.find(".mpSearchClear").click(function (e) { // on clear click
                wrapper.find("input").val("").focus();
                e.preventDefault();

                if (options.change) {
                    options.change(""); //trigger change event
                }

                if (options.clear) {
                    options.clear(); //trigger clear event
                }

                //Eugh duplicate code....
                checkForText($(this), wrapper);
            });

            $(this).keyup(function (e) {
                //console.log($.inArray(e.keyCode, invalidKeys));
                if ($.inArray(e.keyCode, invalidKeys) === -1) {
                    if (options.change) {
                        options.change($(this).val()); // change function
                    }
                }

                checkForText($(this), wrapper);
            });

            $(this).keypress(function (e) {
                if (e.keyCode === 13) {
                    if (options.search) {
                        options.search($(this).val()); // search function
                        e.preventDefault();
                        if (options.clearAfterSearch === true) {
                            $(this).val("");
                        }
                    }
                }
            });
        });

        function checkForText($this, wrapper) {
            //console.log("text: " + $this.val());
            if ($this.val().length > 0) {
                wrapper.removeClass("no-text");
            } else {
                wrapper.addClass("no-text");
            }
        };
    };
})(jQuery);


//##########################################
//#region SEARCH
//When you click the top search button, this creates and expands the item
function toggleMainSearch(element){
    var searchButton = $(element);
    var body = $("body");
	var header = searchButton.closest("header");
	var searchWrapper = searchButton.parent();
	var searchInput = header.find("#mainSearchInput");
	var searchType = null;

	if (searchWrapper.data("initalized") === false) {
	    var types = searchWrapper.data("searchtypes");

		//Create the elements
	    searchType = $("#searchOptions").kendoDropDownList({
	        dataSource: types,
	        dataTextField: "Name",
	        dataValueField: "Url",
	        width: 50,
	        change: function (e) {
	            var value = this.value();
	            var text = this.text();
	            var dataItem = this.dataItem();
	            searchInput.data("url", dataItem.Link); //set the search value
	            searchInput.attr("placeholder", "Search " + text + "...");
	            searchInput.data("type", text);
	        }
	    }).data("kendoDropDownList");

	    searchType.list.width("auto");

		searchInput.keypress(function (e) {
			if (e.which === 13) {
			    performSearch(searchInput.data("url"), searchInput.val(), searchInput.data("type"));
			}
		});

		searchWrapper.data("initalized", true);
	}

	if (searchInput.val() !== "") {
	    //If search has text in it, do the redirect
	    if (body.hasClass("search-opened")) {
	        performSearch(searchInput.data("url"), searchInput.val(), searchInput.data("type"));
	    }
	} else {
	    searchInput.val(searchWrapper.data("value"));
	    body.toggleClass("search-opened");

	    if (body.hasClass("search-opened")) {
		    //Toggle On
		    var windowWidth = $(window).width();
		    if (windowWidth < 700) {
		        //Resize search to fill container
		        searchWrapper.css({
		            width: windowWidth
		        });
		    }

			header.find("#mainSearchInput").focus();
		}else{
		    //Toggle Off
		    searchWrapper.removeAttr("style");
		}
	}
}

function performSearch(url, query, type) {
    sendGATrackingEvent("Top Search", "Search", "Top Search", query);

    setTimeout(function (e) {
        var queryFilter = encodeURIComponent(query);

        if (url === "")
            window.location = "/searchresults?type=" + type + "&term=" + queryFilter;
        else
            window.location = url + queryFilter;

    }, 20);
}

//Searchbox clear the input
function clearSearchBox(element) {
	var target = $(element);
	target.closest(".inputWrap").find("input[type='text']").val('');
}
//#endregion
//##########################################

function getMenuSearchTemplate() {
    return "<li class='search-item' title='#: Keywords #'>\
                <a href='#: FullUrl #'>\
                    <span class='section #: Section #' title='#: Section #'></span>\
                    <span class='title' data-bind='html: Title'></span>\
                    <div class='meta'>\
                        # if(data.Description.length === 0){  #\
                            <span data-bind='html: Description' class='desc search-item invisible'></span>\
                        # }else{  #\
                            <span data-bind='html: Description' class='desc search-item'></span>\
                        # }  #\
                        <span data-bind='text: FullUrl' class='url search-item'></span>\
                    </div>\
                </a>\
            </li>";
}
